<template>
  <NotificationTypeWrapper :notification="notification">
    {{ sendingUnionName }} has
    <a
      :href="actionLink"
      v-text="'shared an item with your organization'"
    />
    .
  </NotificationTypeWrapper>
</template>

<script type="text/babel">
import NotificationTypeMixin from './NotificationTypeMixin'

export default {
  name: 'ItemHasBeenShared',
  mixins: [NotificationTypeMixin],
  computed: {
    sendingUnionName() {
      return this.notification.attributes.data.sending_union_name
    },
    actionLink() {
      return this.$urlGenerator.active() + 'documents/shares'
    },
  },
}
</script>
